import { FC } from "react";

export const HomeIcon: FC<{ className?: string }> = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="21.668" height="19.315" viewBox="0 0 21.668 19.315" fill="var(--primary)">
        <g transform="translate(0.001 -27.798)">
            <g transform="translate(-0.001 27.798)">
                <path d="M21.437,35.426l-10.271-7.52a.563.563,0,0,0-.665,0L.23,35.426a.563.563,0,0,0,.665.909l9.938-7.277,9.938,7.277a.563.563,0,0,0,.665-.908Z" transform="translate(0.001 -27.797)"/>
            </g>
            <g transform="translate(2.388 36.462)">
                <path d="M72.779,232.543a.563.563,0,0,0-.563.563v8.961h-4.5v-4.892a2.815,2.815,0,1,0-5.63,0v4.892h-4.5v-8.961a.563.563,0,1,0-1.126,0v9.524a.563.563,0,0,0,.563.563h5.63a.563.563,0,0,0,.561-.519.425.425,0,0,0,0-.044v-5.455a1.689,1.689,0,1,1,3.378,0v5.455a.413.413,0,0,0,0,.043.563.563,0,0,0,.561.52h5.63a.563.563,0,0,0,.563-.563v-9.524A.563.563,0,0,0,72.779,232.543Z" transform="translate(-56.452 -232.543)"/>
            </g>
        </g>
    </svg>
);